import React, { useState, useEffect } from "react";
import { Layout, Input, Space, Button, Table, message, Form, Popconfirm, Typography, Spin, Select } from "antd";
import { EditFilled, DownOutlined, CheckCircleFilled, CloseCircleFilled, SearchOutlined } from "@ant-design/icons";
import { Redirect } from "react-router-dom";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import axios from "axios";
import Cookies from "js-cookie";
import './Garnishments.css'
import * as XLSX from "xlsx";
const { Header, Content } = Layout;
 
 
const Garnishments = () => {
    const jwtToken = Cookies.get("jwt_token");
    const [garnishmentData, GetGarData] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState("")
    const [tableLoader, setTableLoader] = useState(false);
    const [loader, setLoad] = useState(false)
    const [loaderDownload, setLoadDownload] = useState(false)
    const [disabaleButton, setDisable] = useState(true)
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [file, setFile] = useState(null)
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');

    var temp = 0;
    useEffect(() => {
        if (temp === 0) {
            temp = 1;
            callGarn();
        }
    }, []);
    const callGarn = async() => {
        setTableLoader(true)
        const res = await Garnishments();
        setTableLoader(false)
    }

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            setFile(selectedFile);
        }
        else {
            setFile(null)
            message.error('Please upload a valid Excel file (XLSX format).');
 
        }
 
    };
 
    const isEditing = (record) => record.Id === editingKey;
    const edit = (record) => {
        setDisable(true)
        form.setFieldsValue({
            ...record,
        });
        setEditingKey(record.Id);
    };
 
    const cancel = () => {
        setEditingKey('');
    };
 
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
 
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText("");
        Garnishments();
    };
 
    const getColumnSearchProps = (dataIndex, placeholder) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={placeholder}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ marginBottom: 8, display: "block" }}
                />
                <Space> <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90, backgroundColor: "#003A8C" }}
                >
                    Search
                </Button>
                    <Button
                        onClick={() => handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reset
                    </Button>
                </Space>
            </div>), filterIcon: (filtered) => (
                <SearchOutlined style={{ color: filtered ? "white" : "white" }} />
            ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : "",
    });
 
    const columns = [
        {
            title: 'Entity',
            dataIndex: 'Entity',
            key: 'Entity',
            width: 50,
            editable: true,
        },
        {
            title: 'File_No',
            dataIndex: 'File_No',
            key: 'File_No',
            width: 100,
            editable: true,
            ...getColumnSearchProps("File_No", "Search File No"),
        },
        {
            title: 'SSN',
            dataIndex: 'SSN',
            key: 'SSN',
            width: 80,
            editable: true,
        },
        {
            title: 'Employee',
            dataIndex: 'Employee',
            key: 'Employee',
            width: 100,
            editable: true,
        },
        {
            title: 'Garnishment Type',
            dataIndex: 'Garnishment_type',
            key: 'Garnishment_type',
            width: 140,
            editable: true,
        },
        {
            title: 'Case',
            dataIndex: 'Case',
            key: 'Case',
            width: 80,
            editable: true,
        },
        {
            title: 'Add Info',
            dataIndex: 'Add_Info',
            key: 'Add_Info',
            width: 80,
            editable: true,
        },
        {
            title: 'Amount/Percentage',
            dataIndex: 'Amount_Percentage',
            key: 'Amount_Percentage',
            width: 150,
            editable: true,
        },
        {
            title: 'Pay Frequency Code',
            dataIndex: 'Pay_frequency_code',
            key: 'Pay_frequency_code',
            width: 150,
            editable: true,
        },
        {
            title: 'Verified in Paychex',
            dataIndex: 'Verified_in_paychex',
            key: 'Verified_in_paychex',
            width: 150,
            editable: true,
        },
        {
            title: 'Mode of deduction',
            dataIndex: 'Mode_of_deduction',
            key: 'Mode_of_deduction',
            width: 150,
            editable: true,
        },
        {
            title: 'City',
            dataIndex: 'City',
            key: 'City',
            width: 80,
            editable: true,
        },
        {
            title: 'Gross/Disposable Income',
            dataIndex: 'Gross_disposable_income',
            key: 'Gross_disposable_income',
            width: 200,
            editable: true,
        },
        {
            title: 'Creditor Address',
            dataIndex: 'Creditor_Address',
            key: 'Creditor_Address',
            width: 140,
            editable: true,
        },
        {
            title: 'Input Date',
            dataIndex: 'Input_date',
            key: 'Input_date',
            width: 100,
            editable: true,
        },
        {
            title: 'Limit',
            dataIndex: 'Limit',
            key: 'Limit',
            width: 80,
            editable: true,
        },
 
        {
            title: 'Remarks',
            dataIndex: 'Remarks',
            key: 'Remarks',
            width: 80,
            editable: true,
        },
 
        {
            title: 'IsValidated',
            dataIndex: 'IsValidated',
            width: 120,
            filters: [
                {
                    text: 'Yes',
                    value: 'Yes',
                },
                {
                    text: 'No',
                    value: 'No',
                },
                {
                    text: 'Both',
                    value: 'Both',
                },
            ],
            onFilter: (value, record) => {
                if (value === 'Both') {
                    return true;
                } else if (value === 'Yes') {
                    return record.IsValidated && record.IsValidated.startsWith('Yes');
                } else if (value === 'No') {
                    return record.IsValidated && record.IsValidated.startsWith('No');
                }
                return false;
            },
            filterIcon: (filtered) => (
                <DownOutlined style={{ color: filtered ? "white" : "white" }} />),
            // width: '40%',
            fixed: 'right',
        },
 
        {
            title: 'Action',
            dataIndex: 'operation',
            fixed: "right",
            width: 80,
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Popconfirm title="Sure to save?" onConfirm={() => editfileRowData(record)} onCancel={cancel}>
                            <Typography.Link
                                style={{
                                    marginRight: 8,
                                }}
                                disabled={disabaleButton}
                            >
                                <CheckCircleFilled style={{ fontSize: 19, color: 'green' }} className="save-cancel-icon" />
                            </Typography.Link>
                        </Popconfirm>
                        <Typography.Link onClick={() => cancel()}>
                            <CloseCircleFilled style={{ fontSize: 19, color: 'red' }} className="save-cancel-icon" />
                        </Typography.Link>
                    </span>
                ) : (
                    <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                        <EditFilled style={{ fontSize: 18, color: '#003A8C' }} />
                    </Typography.Link>
                );
            },
        },
    ];
 
    const EditableCell = ({
        editing,
        dataIndex,
        title,
        inputType,
        record,
        index,
        children,
        ...restProps
    }) => {
        const inputNode = <Input />;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                        onChange={()=>setDisable(false)}
                        // rules={[
                        //     {
                        //         required: true,
                        //         message: `Please Input ${title}!`,
                        //     },
                        // ]}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
 
    const onSelectChange = (selectedKeys) => {
        setSelectedRowKeys(selectedKeys);
    };
 
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
 
    //Api for getting all records
    const Garnishments = async () => {
        try {
            axios({
                url:
                    `${process.env.REACT_APP_BASE_URL}Garnishments/GetGarnishments`,
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            })
                .then((resp) => {
                    GetGarData(resp.data)
                    // setFile([])
                })
 
        }
        catch (error) { 
            message.error("Unable to load data...")
        }
    };

    //Api for uploading file
    // const duplicate = "";
    // const [warn, setWarn] = useState([]);
    const handleUpload = () => {
        if (!file) {
            message.error("Please upload a file")
        }
        else {
            setTableLoader(true)
            const formData = new FormData();
            formData.append('file', file);
            axios.post(`${process.env.REACT_APP_BASE_URL}Garnishments/GarnishmentsUpload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${jwtToken}`,
                }
            })
                .then((response) => {
                    const resdata = response.data
                    // duplicate = resdata.message
                    if (resdata.isSuccess == false && resdata.message == "Duplicate records found. Please check your data.") {
                        // setWarn(duplicate)
                        message.warning('Duplicate records found. Please check your data.');
                        setTableLoader(false)
                        Garnishments()
                    }
                    else {
                        message.success('Uploaded successfully.');
                        setTableLoader(false)
                        Garnishments()
                    }
                })
                .catch((error) => {
                    message.error('Error while uploading file');
                    setTableLoader(false)
                })
        }
    };
    // console.log(warn)
    //Api for Update table records
    const editfileRowData = async (props) => {
        try {
            const currentRowData = await form.getFieldValue();
            const data = {
                "id": currentRowData.Id,
                "entity": currentRowData.Entity,
                "file_no": currentRowData.File_No,
                "ssn": currentRowData.SSN,
                "employee": currentRowData.Employee,
                "garnishment_type": currentRowData.Garnishment_type,
                "case": currentRowData.Case,
                "add_Info": currentRowData.Add_Info,
                "amount_Percentage": currentRowData.Amount_Percentage,
                "pay_frequency_code": currentRowData.Pay_frequency_code,
                "verified_in_paychex": currentRowData.Verified_in_paychex,
                "mode_of_deduction": currentRowData.Mode_of_deduction,
                "city": currentRowData.City,
                "gross_disposable_income": currentRowData.Gross_disposable_income,
                "creditor_Address": currentRowData.Creditor_Address,
                "input_date": currentRowData.Input_date,
                "limit": currentRowData.Limit,
                "status": currentRowData.Status,
                "remarks": currentRowData.Remarks
            }
            const config = {
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                }
            }
            const url = `${process.env.REACT_APP_BASE_URL}Garnishments/UpdateGarnishment`
            const response = await
                axios.put(url, data, config)
                    .then((response) => {
                        message.success(`Updated successfully.`);
                    })
            Garnishments();
            setEditingKey("");
        }
        catch (err) {
            return err
        }
 
    }
 
    //Api for validating records
    const ValidateRecords = async () => {
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            }
        }
        setLoad(true)
        const url = `${process.env.REACT_APP_BASE_URL}Garnishments/ValidateGarnishment`
        const data = selectedRowKeys
        const response = await
            axios.put(url, data, config)
                .then((response) => {
                    message.success(`Validated successfully.`);
                    setLoad(false)
                })
        Garnishments()
    };
 
    //garnishments file download method
    const handleGarnishments = async (props) => {
        let value = props.value;
        setLoadDownload(true);
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_BASE_URL}Garnishments/DownloadFile?Validate=` + value,
                {
                    headers: {
                        "content-type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    },
                }
            );
            let resdata = res.data;
            handleGarnishmentList(resdata)
        } catch (err) {
            setLoadDownload(false);
            message.error("Cannot able download, please try again")
        }
    };
 
    const handleGarnishmentList = (props) => {
        let sampleList = props;
        let loopedList = [];
        loopedList.length = 0;
        let len = sampleList.length;
        let i;
        for (i = 0; i < len; i++) {
            loopedList.push({
                Entity: sampleList[i].entity,
                File_No: sampleList[i].file_No,
                SSN: sampleList[i].ssn,
                Employee: sampleList[i].employee,
                Garnishment_type: sampleList[i].garnishment_type,
                Case: sampleList[i].case,
                Add_Info: sampleList[i].add_Info,
                Amount_Percentage: sampleList[i].amount_Percentage,
                Pay_frequency_code: sampleList[i].pay_frequency_code,
                Verified_in_paychex: sampleList[i].verified_in_paychex,
                Mode_of_deduction: sampleList[i].mode_of_deduction,
                City: sampleList[i].city,
                Gross_disposable_income: sampleList[i].gross_disposable_income,
                Creditor_Address: sampleList[i].creditor_Address,
                Input_date: sampleList[i].input_date,
                Limit: sampleList[i].limit,
                IsValidated: sampleList[i].isValidated,
            });
        }
        setLoadDownload(false);
        handleOnGarnishmentExport(loopedList);
    };
 
    const handleOnGarnishmentExport = (props) => {
        const listData = props;
        var wb = XLSX.utils.book_new(),
            ws = XLSX.utils.json_to_sheet(listData);
        XLSX.utils.book_append_sheet(wb, ws, "Myfile");
        XLSX.writeFile(wb, "Garnishments.xlsx");
    };
 
 
    if (jwtToken === undefined) {
        return <Redirect to="/" />;
    }
    return (
        <>
            <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
                <SideNavBar />
                <Layout className="whole-div">
                    <Header className="timecards-header">
                        <Navbar />
                    </Header>
                    <Content >
                        <h1 className="garnishments-title">Garnishments</h1>
                        <div>
                            <div className="garnishmnet-input-div">
                                <div>
                                    <input type="file" accept=".xlsx" onChange={handleFileChange} />
                                    <Button onClick={handleUpload} className="upload-file">Upload</Button>
                                </div>
                                <div>
                                    <Select
                                        labelInValue
                                        defaultValue={{
                                            value: 'Download File',
                                            label: 'Download File',
                                        }}
                                        style={{
                                            width: 170
                                        }}
                                        onSelect={handleGarnishments}
                                        options={[
                                            {
                                                value: 'Yes',
                                                label: 'With Validated',
                                            },
                                            {
                                                value: 'No',
                                                label: 'Without Validated',
                                            },
                                            {
                                                value: 'Both',
                                                label: 'All',
                                            },
                                        ]}
                                        className="preview-frequency-select"
                                        loading={loaderDownload}
                                    />
                                </div>
                            </div>
                            <div className="garnishmnet-table-div">
                                {
                                    tableLoader ? <Spin tip="Loading...">
                                        <Form form={form} component={false}>
                                            <Table className="garnishments-table" rowClassName="editable-row"
                                                components={{ body: { cell: EditableCell, }, }}
                                                bordered
                                                scroll={{ x: "max-content", y: 280 }}
                                                columns={mergedColumns}
                                                dataSource={garnishmentData.map(item => ({ ...item, key: item.Id }))}
                                                rowSelection={rowSelection}
 
                                            />
                                        </Form>
                                    </Spin> : garnishmentData ?
                                        <Form form={form} component={false}>
                                            <Table className="garnishments-table" rowClassName="editable-row"
                                                components={{ body: { cell: EditableCell, }, }}
                                                columns={mergedColumns}
                                                bordered
                                                dataSource={garnishmentData.map(item => ({ ...item, key: item.Id }))}
                                                scroll={{ x: "max-content", y: 280 }}
                                                rowSelection={rowSelection}
                                            />
                                        </Form>
                                        : null
                                }
                            </div>
                            <div className="garnishmnet-buttons-div">
                                <Button className="validate-garnishment" loading={loader} onClick={ValidateRecords}>Validate</Button>
                            </div>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </>
    )
}
export default Garnishments;